export type NowReference = {
  serverNow: Date;
  clientNow: Date;
};

export type ServerDateNow = undefined | (() => Date);

export const getServerDateNow = (nowReference: NowReference): Date => {
  const timeDiff = new Date().getTime() - nowReference.clientNow.getTime();
  return new Date(nowReference.serverNow.getTime() + timeDiff);
};
